module.exports = __webpack_public_path__ + "img/more.a2180016.png";